export const iconFontAwesomeHumanitarianTrowel = (
	<i className="fa-solid fa-trowel"></i>
);
